export const isLoggedInViaGoogle = () => localStorage.getItem('loginMethod')?.includes('Google');
